export default "/img/Taurus.png"